/* eslint quotes: off */
export const isFieldEmpty = fieldValue => {
  if (!fieldValue) {
    return true;
  }
  if (typeof fieldValue === "string") {
    if (fieldValue.trim() === "") {
      return true;
    }
    //eslint-disable-next-line
    if (fieldValue.replace(new RegExp("\n", "g"), "") === "") {
      return true;
    }
  }
  return false;
};
export const getEmptyFieldMessage = fieldName => {
  if (!fieldName) {
    return "Must not be empty";
  }
  return `${fieldName} must not be empty`;
};
export const isStringUUID = value => {
  if (!value) {
    return false;
  }
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(value);
};
export const validateMultiWords = (values, isWordValid) => {
  const removeAdditionalQuotes = (arr, newWord, index) => {
    let word = newWord;
    if (index === 0 && word.substr(0, 1) === `"`) {
      word = word.substr(1);
    } else if (index === arr.length - 1 && word.substr(word.length - 1, 1) === `"`) {
      word = word.substr(0, word.length - 1);
    }
    return word;
  };
  try {
    if (values.substr(0, 1) === `"` && values.substr(values.length - 1, 1) === `"`) {
      if ((values.match(/",/g) || []).length === (values.match(/,"/g) || values.match(/, "/g) || []).length) {
        const wordArr = values.split(`","`);
        const wordArr1 = values.split(`", "`);
        const wordList = [];
        const validationErrors = [];
        const wordArrMap = wordArr.length >= wordArr1.length ? wordArr : wordArr1;
        const validateAndAdd = newWord => {
          if (typeof isWordValid === "function") {
            if (isWordValid(newWord)) {
              wordList.push(newWord);
            } else {
              validationErrors.push(newWord);
            }
          } else {
            wordList.push(newWord);
          }
        };
        if (wordArrMap.length === 1) {
          const word = wordArrMap[0].replace(RegExp(`"`, "g"), "");
          validateAndAdd(word);
          return {
            wordList,
            hasError: false,
            validationErrors
          };
        } else if (wordArrMap.length >= 2 && wordArrMap[1] !== "") {
          wordArrMap.map((word, index) => {
            const newWordArr = word.split(wordArr.length >= wordArr1.length ? `", "` : `","`);
            if (newWordArr.length >= 2) {
              newWordArr.map((item, index1) => {
                const newWord = removeAdditionalQuotes(newWordArr, item, index1);

                //wordList = [...wordList, newWord];
                validateAndAdd(newWord);
              });
            } else {
              const newWord = removeAdditionalQuotes(wordArrMap, word, index);
              //wordList = [...wordList, newWord];
              validateAndAdd(newWord);
            }
          });
          return {
            wordList,
            hasError: false,
            validationErrors
          };
        } else {
          return {
            wordList: [],
            hasError: true,
            validationErrors: []
          };
        }
      } else {
        return {
          wordList: [],
          hasError: true,
          validationErrors: []
        };
      }
    } else if (values.substr(0, 1) === `"` && values.substr(values.length - 1, 1) !== `"` || values.substr(0, 1) !== `"` && values.substr(values.length - 1, 1) === `"` || values.indexOf(`,`) > 0 || values.split(`","`).length > 1 || values.split(`", "`).length > 1) {
      return {
        wordList: [],
        hasError: true,
        validationErrors: []
      };
    } else {
      return {
        wordList: [],
        hasError: false,
        validationErrors: []
      };
    }
  } catch (error) {
    return {
      wordList: [],
      hasError: true,
      validationErrors: []
    };
  }
};